import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'antd';
import styles from './SiderMenu.module.less';

const { Item } = Menu;

function getSubRoutesItems(subRoutes, permissions, t) {

  const items = subRoutes.map((subRoute) => {

    const { menuItem: subMenuItemTemp, path: subPath, key } = subRoute;
    if (!subMenuItemTemp) return null;
    const subMenuItems = !Array.isArray(subMenuItemTemp) ? [subMenuItemTemp] : subMenuItemTemp;

    // eslint-disable-next-line no-shadow
    const items = [];

    subMenuItems.forEach((subMenuItem) => {

      const {
        name: subName,
        icon: subIcon,
        path: pathItem = subPath,
        key: keyPath = key,
        permisionReq,
      } = subMenuItem;

      if (
        permisionReq
        && permissions
        && !permisionReq.every((strPermission) => permissions.includes(strPermission))
      ) {

        return;

      }

      items.push(
        // eslint-disable-next-line react/jsx-filename-extension
        <Item className={styles.submenu_item} key={keyPath} icon={subIcon}>
          <Link to={pathItem}>{t(subName)}</Link>
        </Item>,
      );

    });

    return items;

  });

  return items;

}

export default getSubRoutesItems;
